import VueGtag from "vue-gtag"
import router from '../router/index-router'
import Vue from 'vue'

Vue.use(VueGtag, {
    config: { id: "G-B2RX12P34Z" }
  }, router);
